import React, { useState, useEffect } from "react";
import {
  makeStyles,
  TextareaAutosize,
  Grid,
  TextField,
  InputLabel,
  Button,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel
} from "@material-ui/core";
import AddressTypes from "../../../enums/AddressTypes";

import useDebouncedCallback from "../../../utils/useDebouncedCallback";
import PlacesInput from "./PlacesInput";

const useStyles = makeStyles(theme => ({
  TextField: {
    width: "100%",
    margin: theme.spacing(1)
  },
  TextArea: {
    width: "100%",
    border: "1px solid rgba(0, 0, 0, 0.42)",
    marginTop: theme.spacing(1),
    fontSize: "1rem"
  },
  textAreaItem: {
    margin: theme.spacing(1)
  },
  radioControl: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1)
  },
  shippingArea: {
    margin: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: "#57be8c",
    color: "white"
  },
  shippingAreaInvalid: {
    margin: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: "#c54848",
    color: "white"
  }
}));

const AddressTabInput = ({
  initialValues = {},
  onChange,
  autosave = false,
}) => {
  const classes = useStyles();

  // Places API State
  const [selectedAddress, setSelectedAddress] = useState(null);

  // Form States
  const [addressType, setAddressType] = useState(
    initialValues.type || "building"
  );

  const [city, setCity] = useState(initialValues.city || "");
  const [street, setStreet] = useState(initialValues.address_street || "");
  const [streetNumber, setStreetNumber] = useState(initialValues.address_street_number || "");
  const [entrance, setEntrance] = useState(initialValues.entrance || "");
  const [apt, setApt] = useState(initialValues.apt || "");
  const [floor, setFloor] = useState(initialValues.floor || "");
  const [notes, setNotes] = useState(initialValues.notes || "");
  const [buildingCode, setBuildingCode] = useState(initialValues.buildingCode || "");


  // Debounce Save function
  const saveChanges = useDebouncedCallback(() => {
    onChange(
      {
        ...selectedAddress,
        address_street: street,
        address_street_number: streetNumber,
        addressType,
        apt,
        floor,
        entrance,
        notes,
        buildingCode,
        city
      }
    );
  }, 500);

  useEffect(() => {
    if (autosave) {
      saveChanges();
    }
    return () => {};
  }, [addressType, floor, notes, apt, entrance, selectedAddress, buildingCode, street, streetNumber, city]);

  return (
    <Grid container direction="column">
      <Grid container direction="row">
        <Grid item xs={12} className={classes.AddressField}>
          <FormControl className={classes.radioControl} required={true}>
            <RadioGroup
              row
              value={addressType}
              onChange={event => {
                setAddressType(event.target.value);
              }}
            >
              {Object.entries(AddressTypes).map(([value, label]) => (
                <FormControlLabel
                  value={value}
                  control={<Radio/>}
                  key={value}
                  label={label}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid item xs={4} className={classes.AddressField}>
          <PlacesInput
            value={city}
            onChange={value => {
              // resetState();
              setCity(value);
            }}
          />
        </Grid>
        <Grid item xs={4} className={classes.AddressField}>
          <TextField
            autoComplete="off"
            label="Street"
            type="text"
            className={classes.TextField}
            fullWidth
            value={street}
            onChange={event => {
              console.log(event.target.value)
              setStreet(event.target.value);
            }}
          />
        </Grid>
        <Grid item xs={4} className={classes.AddressField}>
          <TextField
            autoComplete="off"
            label="Street-Number"
            type="text"
            className={classes.TextField}
            fullWidth
            value={streetNumber}
            onChange={event => {
              setStreetNumber(event.target.value);
            }}
          />
        </Grid>
        <Grid item xs={1} className={classes.AddressField}>
          <TextField
            autoComplete="off"
            label="Ent."
            className={classes.TextField}
            value={entrance}
            onChange={event => {
              setEntrance(event.target.value);
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={1} className={classes.AddressField}>
          <TextField
            autoComplete="off"
            label="Floor"
            type="number"
            className={classes.TextField}
            value={floor}
            onChange={event => {
              setFloor(event.target.value);
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={1} className={classes.AddressField}>
          <TextField
            autoComplete="off"
            label="Apt"
            type="text"
            className={classes.TextField}
            value={apt}
            onChange={event => {
              setApt(event.target.value);
            }}
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid item xs={5} className={classes.AddressField}>
        <TextField
          autoComplete="off"
          label="Building Code"
          type="text"
          className={classes.TextField}
          fullWidth
          value={buildingCode}
          onChange={event => {
            setBuildingCode(event.target.value);
          }}
        />
      </Grid>
      <Grid item className={classes.textAreaItem}>
        <InputLabel>Address Notes</InputLabel>
        <TextareaAutosize
          rows={3}
          className={classes.TextArea}
          value={notes}
          onChange={event => {
            setNotes(event.target.value);
          }}
        />
      </Grid>
      {!autosave && (
        <Grid container direction="row" alignItems="center">
          <Grid item xs={2}>
            <Button
              onClick={saveChanges}
              variant="contained"
              color="primary"
              fullWidth
            >
              Save
            </Button>
          </Grid>
          <Grid item xs={1}/>
          <Grid item xs={9} className={classes.AddressField}></Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default AddressTabInput;
